import React, { useState, Fragment } from 'react';
import TagsInput from 'react-tagsinput';
import {
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Collapse,
  Card,
  CardBody,
  CardTitle,
  Input,
  Label,
  CustomInput,
  Badge,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  faCommentDots,
  faEdit,
  faTrashAlt,
  faLaptopCode,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function QuestionOptionsResponse({
  dialogUpdate,
  elem,
  dialogIndex,
  codeIndex,
  message,
  dialogNames,
}) {
  const [isEditing, setIsEditing] = useState(false);
  const [dialogTags, setDialogTags] = useState(
    message.options === undefined ? [] : message.options
  );
  const [messageInput, setMessageInput] = useState(message);

  const [deleteVisible, setDeleteVisible] = useState(false);
  const [postData, setPostData] = useState(elem);
  const handleEdit = () => {
    setIsEditing(true);
  };
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const handleDelete = () => {
    const data = { ...postData };
    data.messages.splice(codeIndex, 1);
    dialogUpdate(postData, dialogIndex);
    toggle();
  };
  const handleCheckChange = (e) => {
    setMessageInput({
      ...messageInput,
      [e.target.name]: e.target.checked,
    });
  };
  const handleTextChange = (e) => {
    setMessageInput({
      ...messageInput,
      [e.target.name]: e.target.value,
    });
  };
  function generateRandomColor() {
    var arr = [
      'primary',
      'secondary',
      'info',
      'success',
      'warning',
      'danger',
      'light',
      'dark',
    ];
    return arr[Math.floor(Math.random() * arr.length)];
  }
  const handleSave = () => {
    const data = { ...postData };
    if (messageInput.question !== '') {
      data.messages[codeIndex].question = messageInput.question;
    } else {
      if (data.messages[codeIndex].question) {
        delete data.messages[codeIndex].question;
      }
    }
    if (messageInput.slot !== '') {
      data.messages[codeIndex].slot = messageInput.slot;
    } else {
      if (data.messages[codeIndex].slot) {
        delete data.messages[codeIndex].slot;
      }
    }
    if (messageInput.after !== '') {
      data.messages[codeIndex].after = messageInput.after;
    } else {
      if (data.messages[codeIndex].after) {
        delete data.messages[codeIndex].after;
      }
    }

    //data.messages[codeIndex].alwaysask = messageInput.alwaysask;
    //data.messages[codeIndex].showButtons = messageInput.showButtons;
    data.messages[codeIndex].options = dialogTags;

    dialogUpdate(data, dialogIndex);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setIsEditing(false);
    setDialogTags(message.options === undefined ? [] : message.options);
    setMessageInput(message);
  };

  const handleTagChange = (event) => {
    setDialogTags(event);
    if (event.length > 0) {
      setMessageInput({
        ...messageInput,
        showButtons: true,
      });
    } else {
      setMessageInput({
        ...messageInput,
        showButtons: false,
      });
    }
  };
  return (
    <Card className="mb-2">
      <CardBody>
        {isEditing ? (
          <Fragment>
            {' '}
            <CardTitle>
              <Row>
                {/* <pre>{JSON.stringify(postData, null, 2)}</pre> */}
                <Colxx xxs="6">
                  <FontAwesomeIcon icon={faCommentDots} />
                  <span> </span>
                  Ask a Question
                </Colxx>
                <Colxx xxs="6">
                  <div className="float-right">
                    <Button
                      color="primary"
                      className="add-button"
                      size="xs"
                      onClick={handleSave}
                    >
                      Save
                    </Button>
                    <b> </b>
                    <Button
                      color="secondary"
                      className="add-button"
                      size="xs"
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                  </div>
                </Colxx>
              </Row>{' '}
            </CardTitle>
            <Row>
              <Colxx xxs="12" className="mb-2">
                <Label>Question</Label>
                <Input
                  type="text"
                  defaultValue={
                    messageInput.question ? messageInput.question : ''
                  }
                  onChange={handleTextChange}
                  name="question"
                />
              </Colxx>
            </Row>
            <Row className="mb-2">
              <Colxx xxs="3">
                <Label>Save to Slot</Label>
                <Input
                  type="text"
                  value={messageInput.slot ? messageInput.slot : ''}
                  onChange={handleTextChange}
                  name="slot"
                />
              </Colxx>
              <Colxx xxs="3">
                <Label>Say After</Label>
                <Input
                  type="text"
                  value={messageInput.after ? messageInput.after : ''}
                  onChange={handleTextChange}
                  name="after"
                />
              </Colxx>
              <Colxx xxs="3">
                <Label>Always Ask</Label>
                <CustomInput
                  type="checkbox"
                  checked={messageInput.alwaysask}
                  name="alwaysask"
                  onChange={handleCheckChange}
                  disabled="disabled"
                />
              </Colxx>
              <Colxx xxs="3">
                <Label>Show Buttons</Label>
                <CustomInput
                  type="checkbox"
                  checked={messageInput.showButtons}
                  name="showButtons"
                  onChange={handleCheckChange}
                  disabled="disabled"
                />
              </Colxx>
            </Row>
            <Row>
              <Colxx xxs="12">
                <TagsInput
                  inputProps={{ placeholder: 'Add Suggested Response' }}
                  value={dialogTags}
                  onChange={(event) => handleTagChange(event)}
                />
              </Colxx>
            </Row>
          </Fragment>
        ) : (
          <Fragment>
            <CardTitle>
              <Row>
                <Colxx xxs="8">
                  <FontAwesomeIcon icon={faCommentDots} />
                  <span> </span>
                  Ask a Question
                </Colxx>
                <Colxx xxs="4">
                  <div className="float-right">
                    <FontAwesomeIcon
                      icon={faEdit}
                      color="#90caf9"
                      cursor="pointer"
                      onClick={handleEdit}
                    />
                    <b> | </b>
                    <FontAwesomeIcon
                      icon={faTrashAlt}
                      style={{ color: 'var(--theme-color-1)' }}
                      cursor="pointer"
                      onClick={toggle}
                    />
                  </div>
                </Colxx>
              </Row>
            </CardTitle>
            <Row>
              <Colxx xxs="12">
                <p>
                  <b>Question: </b>
                  {messageInput.question}
                </p>
                {messageInput.slot && (
                  <p>
                    <b>Save to Slot: </b>
                    {messageInput.slot}
                  </p>
                )}
                {messageInput.after && (
                  <p>
                    <b>Say After: </b>
                    {messageInput.after}
                  </p>
                )}
                {messageInput.alwaysask !== undefined && (
                  <p>
                    <b>Always Ask: </b>
                    {messageInput.alwaysask.toString()}
                  </p>
                )}
                {messageInput.showButtons !== undefined && (
                  <p>
                    <b>Show Buttons: </b>
                    {messageInput.showButtons.toString()}
                  </p>
                )}
              </Colxx>
            </Row>
            <Row>
              <Colxx xxs="12">
                {messageInput.options && (
                  <Fragment>
                    {messageInput.options.map((tag, index) => {
                      return (
                        <Fragment>
                          {' '}
                          <Badge color={generateRandomColor()}>
                            {tag}
                          </Badge>{' '}
                        </Fragment>
                      );
                    })}
                  </Fragment>
                )}
              </Colxx>
            </Row>
            <Modal isOpen={deleteVisible} toggle={toggle}>
              <ModalHeader toggle={toggle}>
                <span role="img" aria-label="warning">
                  ⚠️
                </span>
                This message will be deleted!
              </ModalHeader>
              <ModalBody>
                <Button color="danger" onClick={() => handleDelete()} size="xs">
                  Delete
                </Button>
                <Button
                  className="ml-2"
                  color="dark"
                  outline
                  size="xs"
                  onClick={toggle}
                >
                  Cancel
                </Button>
              </ModalBody>
            </Modal>
          </Fragment>
        )}
      </CardBody>{' '}
    </Card>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};
export default injectIntl(connect(mapStateToProps)(QuestionOptionsResponse));
